module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showInstanceEditor) ? _c('EditBar', {
    attrs: {
      "row": _vm.componentInstance,
      "columns": _vm.visibleColumns,
      "updateRow": _vm.modifyComponentInstance,
      "destroy": _vm.destroyComponent
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46185816!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComponentInstanceEditBar.vue
// module id = 747
// module chunks = 2